import createAxiosClient, { config } from "../utils/api-utils";
class InterestApi {
  constructor() {
    this.client = createAxiosClient();
  }
  async addInterest(data) {
    const reqData = {
      toId: data,
    };
    return await this.client.post("/interests", reqData, config());
  }

  async getRequest(type = 'received') {
    return await this.client.get(`/interests?type=${type}`, config());
  }

  async updateInterest(id, data) {
    return await this.client.patch(`/interests/${id}`, data, config());
  }
}
export default InterestApi = new InterestApi();
